import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "./Button/Button";


const CourseSlider = () => {
  const [allCourse, setAllCourse] = useState([]);
  const [hovered, setHovered] = useState(Array(allCourse.length).fill(false));
  // const [selectedItem, setSelectedItem] = useState();
  const navigate = useNavigate();

  try {
    useEffect(() => {
      axios.get("https://lawacademyadmin.icicle.dev/api/courseAll").then((res) => {
        setAllCourse(res.data);
      });
    }, []);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      confirmButtonText: "Ok",
      confirmButtonColor: "red",
    });
  }

 

  // handleApplyButton
  const handleApplyNow = (item) => {
    navigate(`/lower-court-sr?data=${JSON.stringify(item.title)}`);
  };

  // useEffect(() => {
  //   if (selectedItem) {
  //     navigate("/lower-court-sr", { data: selectedItem });
  //   }
  // }, [selectedItem, navigate]);

  //----- mouse Enter
  const handleMouseEnter = (index) => {
    const updateHovered = [...hovered];
    updateHovered[index] = true;
    setHovered(updateHovered);
  };
  //----- mouse leave
  const handleMouseLeave = (index) => {
    const updatedHovered = [...hovered];
    updatedHovered[index] = false;
    setHovered(updatedHovered);
  };

  const cardStyle = {
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "20px",
    textAlign: "center",
    width: "270px",
    height: "300px",
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
  };

  const imageStyle = {
    width: "100%",
    borderRadius: "8px",
    marginBottom: "15px",
    transition: "transform 0.3s",
  };

  return (
    <>
      <div className="upcoming-event">
        <div className="container">
          <div className="row" style={{ marginTop: "30px" }}>
            <h3
              className="heading-regular"
              variant="h4"
              align="center"
              style={{
                paddingBottom: "15px",
                color: "#2d2d2d",
                fontWeight: "bold",
                fontFamily: "sans-serif",
              }}
            >
              Course List
            </h3>
            <div className="row">
              {allCourse.slice(0, 4).map((item, index) => (
                <div
                data-aos="fade-up"
                  key={index}
                  className="col-sm-6 col-md-3"
                  style={{ display: "flex", justifyContent: "center", paddingRight: "0px" }}
                >
                  <div
                    className="image-container "
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={() => handleMouseLeave(index)}
                    style={cardStyle}
                  >
                    <img
                      className="zoom-image"
                      src={`https://lawacademyadmin.icicle.dev/${item?.image}`}
                      alt="Course_list"
                      style={imageStyle}
                    />
                    <div
                      className=""
                      style={{
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <h3 style={{ color: "black", fontWeight: "500" }}>{item.title}</h3>
                    </div>
                    <div onClick={() => handleApplyNow(item)} style={{ marginTop: "10px" }}>
                      <Button title={"Apply Now"}></Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CourseSlider;
